import React from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
      style={{ marginTop: "0" }}
    >
      <div className="bg-neutral-800 rounded-2xl w-full max-w-2xl p-6 shadow-2xl relative overflow-y-auto max-h-[80vh] border border-neutral-700">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-neutral-400 hover:text-white transition-colors"
        >
          ✕
        </button>
        {title && (
          <h2 className="text-xl font-bold text-white mb-4">{title}</h2>
        )}
        <div className="space-y-4 text-neutral-300">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
